import CryptoJS from "crypto-js";
const SECRET_KEY = "H7d9K2mN4xWpQsErT5v8YzLuJqC0AixnAMs"; // Must match backend

export function encryptPayload(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
}

export function decryptPayload(ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
}